import {gql} from '@apollo/client';

/// waitList
export const listQuery = gql`
query getWaitList($path: String!) {
	list(path: $path) {
		id
		location
		due
		captured
		incentives {
			id
			target
			outcome
		}
		desktop {
			id
			url
		}
		mobile {
			id
			url
		}
		logo {
			id
			url
		}
	}
}`;

/// booked-appointments
export const getAppointmentsQuery = gql`
    query {
        auth {
            id
            user {
                id
                appts {
                    id
                    details {
                        id
                        location {
                            id
                            details {
                                id
                                name
                                address {
                                    addr1
                                    addr2
                                }
                                coords {
                                    lat
                                    lng
                                }
                            }
                        }
                        product {
                            id
                            code
                            shortName
                            descriptors {
                                id
                                singular
                            }
                        }
                        start {
                            date: time(fmt: "01/02/06")
                            time(fmt: "03:04pm")
                            unix
                            timezone
                        }
                    }
                    reservation {
                        id
                        canCancel
                        results {
                            id
                            exists
                            file {
                                id
                            }
                        }
                    }
                }
            }
        }
    }`;
